import { ButtonSize, PaginationLoadMore } from '@edikk-edikk/country-layout-black';
import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useApi } from '#hooks/use-api';
import { useAdvertListContext } from '#advertList/hooks';

const LoadMore: FC = () => {
  const {
    advertDataListByDate: {
      pagination,
    },
    categoryId,
    cityId,
    areaId,
  } = useAdvertListContext();
  const api = useApi();
  const [loadMore, { isFetching }] = api.getApiAdvertListByDate().useLazyLoadMoreQuery();

  const renderLoadMoreText = useCallback((countInNextPage: number) => (
    <FormattedMessage
      defaultMessage="Load more {countInNextPage, plural, =1 {# model} other {# models}}"
      values={{ countInNextPage }}
    />
  ), []);

  const handlerLoadMore = (page: number) => {
    loadMore({
      categoryId,
      cityId,
      areaId,
      page,
    });
  };

  return (
    <PaginationLoadMore
      page={pagination.page}
      pageSize={pagination.pageSize}
      totalCount={pagination.totalCount}
      isFetching={isFetching}
      loadMore={handlerLoadMore}
      loadMoreText={renderLoadMoreText}
      btnSize={ButtonSize.lg}
      btnPaddingX5
    />
  );
};

export { LoadMore };
